var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      { class: _vm.buttonClass, on: { click: _vm.onClick } },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("span", [_vm._v(_vm._s(_vm.errorMessage))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }